(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  var typed = new Typed('.type-text', {
    strings: ['Pot Magnets', 'Neodymium Magnets', 'Ring Magnets', 'Block Magnets', 'Magnetic Strips', 'Office Magnets'],
    typeSpeed: 100,
    backSpeed: 100,
    loop: true
  });

  } catch(e) { console.error(e); }
})();
})();
